/**
 * Created by qlong on 9/7/2016.
 */
import React, {Component} from 'react';

export default class ListOption extends Component{
    handleChange(e){
        const changedValue  = e.target.value
        this.props.onChangeFunction(changedValue, this.props.title, e)
    }

    render(){
        const { title, text, isMulti,filters } = this.props
        let listComponents
        let rv = {};
        for (var i = 0; i < text.names.length; ++i)
            rv[text.names[i]] = i;

        const names = [].concat(text.names).sort()
        if (isMulti) {
            listComponents = names.map((cat_name,i) =>
                <div key={cat_name} className={"inlineBlock paddingLeft".concat(i==0? "":" boardLine")}>
                    <div className="fieldTitle">{cat_name}</div>
                    {[...new Set(text.values[rv[cat_name]])].sort(function(a, b) {
                        if (typeof a == "string" && typeof b == "string"){
                            if (a.includes(";") || b.includes(";")){
                                const aArray = a.split(";")
                                const bArray = b.split(";")
                                const longerStr  = aArray.length > bArray.length? a : b
                                const maxLength = aArray.length > bArray.length? aArray.length : bArray.length
                                const minLength = aArray.length > bArray.length? bArray.length : aArray.length

                                for (let i=0; i < maxLength; i++){
                                    if(i>minLength-1){
                                        return longerStr==a? 1 : -1
                                    }
                                    if (aArray[i] != bArray[i]) return aArray[i] - bArray[i]

                                }
                                return 0
                            } else {
                                var nameA = a.toLowerCase() // ignore upper and lowercase
                                var nameB = b.toLowerCase() // ignore upper and lowercase

                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            }

                        } else if(typeof a == "number" && typeof b == "number"){
                            return a-b
                        } else {
                            if (typeof a == "string"){
                                if (a == "") return -1
                                if (a.split(";")[0] == b) return 1

                                return a.split(";")[0] - b
                            }
                            else{
                                if (b == "") return 1
                                if (a == b.split(";")[0]) return -1
                                return a - b.split(";")[0]
                            }

                        }
                    }).map((value, j) =>
                        <div key={cat_name + j}>
                            <input type="checkbox" name={title} value={rv[cat_name] + '@' + value}
                                   checked={filters.includes(rv[cat_name] + '@' + value)}
                                   onChange={this.handleChange.bind(this)}/> {value}
                        </div>
                    )}
                </div>
            )
        }
        else{
            listComponents =  <div className="inlineBlock">
                                    <select value={filters} onChange={this.handleChange.bind(this)}>
                                        {names.map((value) => <option value={rv[value]} key={rv[value]}>{value}</option>)}
                                    </select>
                              </div>
        }
        return (
            <div className="inlineBlock blockBackground">
                <div className="fieldTitle headerTitle">{title}</div>
                {listComponents}
            </div>
        )
    }
}

ListOption.propTypes = {
    title: React.PropTypes.string.isRequired,
    text: React.PropTypes.object.isRequired,
    name: React.PropTypes.string.isRequired,
    isMulti: React.PropTypes.bool,
    onChangeFunction: React.PropTypes.func,
}




/** WEBPACK FOOTER **
 ** ./src/components/ListOption.js
 **/